import React, { createContext, type FunctionComponent, useContext } from 'react'

export type ShowSlugsContext = boolean

interface RoleManagementShowSlugsProviderProps {
  showSlugs: boolean
}

const context = createContext<ShowSlugsContext>(null)

export const RoleManagementShowSlugsProvider: FunctionComponent<
  RoleManagementShowSlugsProviderProps
> = ({ showSlugs, children }) => <context.Provider value={showSlugs}>{children}</context.Provider>

export const useShowSlugsContext = () => useContext(context)
